import { VarKey } from "@swivl-mono/types";
import { Button, ButtonColor, Input, Select, Switch, TextArea } from "@swivl-mono/ui";
import { useEffect } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useNavigate, useParams } from "react-router-dom";
import { shallow } from "zustand/shallow";

import { AvatarWithGenerator } from "../../../Components/AvatarWithGenerator/AvatarWithGenerator";
import { ConversationRestrictionsControls } from "../../../Components/ConversationRestrictionsControls/ConversationRestrictionsControls";
import { QuestsDropdown } from "../../../Components/Dropdowns/QuestsDropdown/QuestsDropdown";
import BrandsModel from "../../../Models/Brands/Brands.Model";
import EmbedsModel from "../../../Models/Embeds/Embeds.Model";
import { Member } from "../../../Models/Member/Member.Current";
import "./Embed.Details.View.scss";

export function EmbedDetailsView() {
  const { embeds } = EmbedsModel.useState((state) => state, shallow);
  const brands = BrandsModel.useState((state) => state.brands);

  const embedId = useParams().embedId;
  const embed = embeds && embedId ? embeds[parseInt(embedId)] : undefined;
  useEffect(() => {
    BrandsModel.load(false);
  }, []);
  const navigate = useNavigate();
  if (!embed) {
    return <div>Embed not found</div>;
  }
  const changeKey = (key: string, value: any) => {
    const b = { ...embed };
    (b as any)[key] = value;
    EmbedsModel.updateEmbed(b);
  };

  const changeProperty = (key: string, value: any) => {
    const b = { ...embed };
    (b as any)[key] = value;
    EmbedsModel.updateEmbed(b);
  };

  const changeSetting = (key: string, value: any, shouldSave = false) => {
    const b = { ...embed };
    (b.settings as any)[key] = value;
    EmbedsModel.updateEmbed(b, shouldSave);
  };
  const onBlur = () => {
    EmbedsModel.updateEmbed(embed, true);
  };
  const limitToGroup = embed.preloadVariables && embed.preloadVariables[VarKey.UserLimitToGroupId] ? true : false;

  return (
    <div className="EmbedDetailsView p-5" key={"mykey" + embed.id}>
      <h3 className="mb-5">
        {" "}
        Chatbot Settings
        <Button
          className="ml-auto"
          color={ButtonColor.WHITE}
          onClickAsync={async () => {
            if (window.confirm("Are you sure you want to delete this embed?")) {
              await EmbedsModel.deleteEmbed(embed.id);
              navigate("/properties/page/chatbots");
            }
          }}
        >
          Delete Chatbot
        </Button>{" "}
      </h3>

      <div className="mb-4 flex flex-row">
        <div className="pr-5">
          <label>Chat Avatar</label>
          <AvatarWithGenerator
            isEditable={true}
            imageURL={embed.settings.avatarURL}
            brandId={embed.brandId}
            brands={brands}
            onImageUploaded={(url) => {
              changeSetting("avatarURL", url, true);
            }}
          />
        </div>

        <div className="position">
          <label>Position</label>
          <table className="positionTable">
            <tbody>
              <tr>
                <td>
                  <button
                    className={"arrowPick left" + (embed.settings.position == "left" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "left", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
                <td></td>
                <td>
                  <button
                    className={"arrowPick right" + (embed.settings.position == "right" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "right", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
              </tr>
              <tr>
                <td>
                  <button
                    className={"arrowPick bottomLeft" + (embed.settings.position == "bottom-left" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "bottom-left", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
                <td>
                  <button
                    className={"arrowPick bottomCenter" + (embed.settings.position == "bottom-center" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "bottom-center", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
                <td>
                  <button
                    className={"arrowPick bottomRight" + (embed.settings.position == "bottom-right" ? " selected" : "")}
                    onClick={(e) => {
                      changeSetting("position", "bottom-right", true);
                    }}
                  >
                    <FiArrowLeft />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="w-1/2">
        <div className="mb-5">
          <div className="mb-10">
            <Input
              name="Name"
              label="Embed Name (Private)"
              value={embed.name}
              containerClassName="mb-4"
              onBlur={onBlur}
              onChange={(e) => {
                changeKey("name", e.target.value);
              }}
            />
            <Input
              name="headerText"
              label="Header Title"
              value={embed.settings.headerText}
              containerClassName="mb-4"
              onBlur={onBlur}
              onChange={(e) => {
                changeSetting("headerText", e.target.value);
              }}
            />

            <Select
              label="Collapsed Type"
              options={[
                { value: "bar", label: "Bar" },
                { value: "dot", label: "Dot" }
              ]}
              selectedValues={[embed.settings.collapsedStyle ? embed.settings.collapsedStyle : "bar"]}
              onChange={(values) => {
                changeSetting("collapsedStyle", values[0], true);
              }}
            />
            {embed.settings.collapsedStyle === "dot" && (
              <>
                <Input
                  name="dotText"
                  label="Dot Title"
                  value={embed.settings.dotText}
                  containerClassName="mb-4"
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("dotText", e.target.value);
                  }}
                />
              </>
            )}

            <Select
              label="Color Theme"
              options={
                brands
                  ? Object.values(brands).map((brand) => {
                      return { value: String(brand.id), label: brand.name };
                    })
                  : []
              }
              selectedValues={embed.brandId ? [String(embed.brandId)] : []}
              onChange={(values) => {
                changeKey("brandId", values[0]);
              }}
              hasSearchInDropdown
            />
          </div>
          <div className="mb-10">
            <label>Call to Action Pop-up</label>
            <Switch
              on={embed.settings.showCTA || false}
              className="mb-2"
              onSet={(checked) => {
                changeSetting("showCTA", checked, true);
              }}
            />

            {embed.settings.showCTA && (
              <div className="mb-10">
                <Input
                  label="CTA Title"
                  value={embed.settings.ctaTitle}
                  containerClassName="mb-4"
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaTitle", e.target.value);
                  }}
                />
                <Input
                  label="CTA Image URL"
                  value={embed.settings.ctaImageURL}
                  containerClassName="mb-4"
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaImageURL", e.target.value);
                  }}
                />

                <label>CTA Body</label>
                <TextArea
                  value={embed.settings.ctaBody}
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaBody", e.target.value);
                  }}
                />

                <label>CTA Delay (seconds)</label>
                <TextArea
                  value={embed.settings.ctaDelay}
                  onBlur={onBlur}
                  onChange={(e) => {
                    changeSetting("ctaDelay", e.target.value);
                  }}
                />

                <QuestsDropdown
                  label="CTA Start On Quest"
                  value={embed.settings.ctaStartOnQuest}
                  onChange={(value) => {
                    changeSetting("ctaStartOnQuest", value, true);
                  }}
                />
              </div>
            )}
          </div>
          <ConversationRestrictionsControls
            restrictionsData={{
              defaultGroup: embed.preloadVariables?.[VarKey.UserDefaultGroupId]
                ? parseInt(embed.preloadVariables[VarKey.UserDefaultGroupId])
                : undefined,
              startOnLocation: embed.preloadVariables?.[VarKey.UserLocationId] ? parseInt(embed.preloadVariables[VarKey.UserLocationId]) : undefined,
              limitedToGroupId: embed.preloadVariables?.[VarKey.UserLimitToGroupId]
                ? parseInt(embed.preloadVariables[VarKey.UserLimitToGroupId])
                : undefined
            }}
            updateRestrictionsData={(data) => {
              const embedData = { ...embed };
              const preloadVariables: any = embedData.preloadVariables || {};
              if (!data.defaultGroup) {
                delete preloadVariables[VarKey.UserDefaultGroupId];
              } else {
                preloadVariables[VarKey.UserDefaultGroupId] = data.defaultGroup;
              }
              if (!data.startOnLocation) {
                delete preloadVariables[VarKey.UserLocationId];
              } else {
                preloadVariables[VarKey.UserLocationId] = String(data.startOnLocation);
              }
              if (!data.limitedToGroupId) {
                delete preloadVariables[VarKey.UserLimitToGroupId];
              } else {
                preloadVariables[VarKey.UserLimitToGroupId] = String(data.limitedToGroupId);
              }
              embedData.preloadVariables = preloadVariables;
              EmbedsModel.updateEmbed(embedData);
            }}
          />

          {Member.isSwivlStaff && (
            <>
              <Input
                label="Embed Slug (for v2 migrations)"
                value={embed.slug || ""}
                containerClassName="mb-4"
                onBlur={onBlur}
                onChange={(e) => {
                  changeProperty("slug", e.target.value);
                }}
              />
            </>
          )}

          {/* 
          <label>Default Settings Group</label>
          
          <LocationsAndGroupsDropdown 
            type={LocationsAndGroupsDropdownType.GROUPS} 
            deselectLabel={"None"}
            onSelect={(groupId, _) => {
              let preloadVariables:any = embed.preloadVariables || {};
              preloadVariables[VarKey.UserDefaultGroup] = String(groupId)
              changeKey('preloadVariables', preloadVariables)
          }} groupId={embed.preloadVariables ? parseInt(embed.preloadVariables[VarKey.UserDefaultGroup]) : undefined}

          />


              <div className="my-3">
          <label>Limit to Group</label>
          <Switch
            on={limitToGroup}
            className="mb-2"
            onSet={(checked) => {
              let preloadVariables:any = embed.preloadVariables || {};
              

              if (!checked) {
                delete preloadVariables[VarKey.UserLimitToGroupId]
              } else {
                preloadVariables[VarKey.UserLimitToGroupId] = groups && Object.values(groups).length ? String(Object.values(groups)[0].id) : ""
              }
              changeKey('preloadVariables', preloadVariables)
              
              
            }} />
            {limitToGroup &&   <LocationsAndGroupsDropdown 
            type={LocationsAndGroupsDropdownType.GROUPS} 
            onSelect={(groupId, _) => {
              let preloadVariables:any = embed.preloadVariables || {};
              preloadVariables[VarKey.UserLimitToGroupId] = String(groupId)
              changeKey('preloadVariables', preloadVariables)

          }} groupId={embed.preloadVariables ? parseInt(embed.preloadVariables[VarKey.UserLimitToGroupId]) : undefined}

          />
            }
</div> */}
        </div>
      </div>
    </div>
  );
}
